import {
    ContentImage,
    ContentText,
} from '@/components/molecules/PremiumOverview'
import bgImg from '/assets/esc-premium-overview-header-bg.png'
import fgImg from '/assets/esc-premium-overview-header-avatar.png'
import { useTranslation } from 'react-i18next'
import { FormattedI18nString } from '@/utils/FormattedI18nString'

export const Header: React.FC = () => {
    const { t } = useTranslation('translations')

    return (
        <div
            className="mt-12 grid grid-cols-1 items-center gap-12 lg:mt-0 lg:grid-cols-2"
            data-testid="premium-overview-header"
        >
            <div className="flex h-full w-full justify-start lg:justify-center">
                <ContentText
                    className="pl-6 lg:ml-auto"
                    title={t('data_management.premiumOverview.header.title')}
                    subtitle={t(
                        'data_management.premiumOverview.header.subtitle'
                    )}
                    footer={
                        <>
                            <span className="text-body-medium">
                                <FormattedI18nString i18nKey="data_management.premiumOverview.header.contact" />
                            </span>
                            <a
                                href="mailto:contact@myenergynetwork.com"
                                className="font-semibold text-blue-500"
                            >
                                {t(
                                    'data_management.premiumOverview.footer.email'
                                )}
                            </a>
                            .
                        </>
                    }
                />
            </div>
            <ContentImage
                bgSrc={bgImg}
                fgSrc={fgImg}
                containerClassName="max-h-[504px]"
                className="h-auto max-h-[313.91px]"
            />
        </div>
    )
}
